/*
* 部门
*/

<template>
  <div class="hbn-container" id="Department_left">
    <el-row :gutter="24">
      <!-- 左部分 -->
      <el-col :span="12">
        <div id="Department_left">
          <div class="search-form">
            <el-row :gutter="12">
              <el-col :span="18">
                <el-form
                  ref="form"
                  :model="form"
                  label-width="80px"
                  label-position="right"
                  size="mini"
                >
                  <el-row :gutter="24">
                    <el-col :span="14">
                      <el-form-item label="部门名称">
                        <el-input
                          id="name"
                          v-model="PageQuery.queryModel.name"
                          placeholder="部门名称"
                          clearable
                        />
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </el-col>
              <el-col :span="6">
                <el-form-item>
                  <el-button
                    size="mini"
                    class="hbn-button-serach"
                    @click="seach"
                    >查找</el-button
                  >
                  <!-- <span class="control-collapse" @click="show = !show">{{
                    show ? "收起" : "展开"
                  }}</span> -->
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <div class="hbn-table-screen">
            <div class="operation">
              <el-button
                style="width: 8rem"
                class="custom-button"
                type="primary"
                @click="DepartmentEdit(-1, 'AddParent')"
              >
                <i class="el-icon-circle-plus-outline custom-icon"></i>
                <span>新增根节点</span>
              </el-button>

              <el-button
                style="width: 8rem"
                class="custom-button"
                type="primary"
                :disabled="currRow.id == undefined || currRow.level == 2"
                @click="DepartmentEdit(0, 'Add')"
              >
                <i class="el-icon-circle-plus-outline custom-icon"></i>
                <span>新增子节点</span>
              </el-button>

              <el-button
                class="custom-button"
                type="primary"
                :disabled="currRow.id == undefined"
                @click="DepartmentEdit(0, 'Modify')"
              >
                <i class="el-icon-circle-edit-outline custom-icon"></i>
                <span>编辑</span>
              </el-button>

              <el-button
                class="custom-button"
                type="primary"
                :disabled="currRow.id == undefined"
                title="请选择一个部门"
                @click="DepartmentEdit(0, 'Delete')"
              >
                <i class="el-icon-circle-del-outline custom-icon"></i>
                <span>删除</span>
              </el-button>

              <el-button
                v-show="false"
                type="primary"
                class="custom-button"
                @click="importExcel"
              >
                <i class="el-icon-upload custom-icon"></i>
                <span>导入</span>
              </el-button>
              <el-button
                v-show="false"
                type="primary"
                class="custom-button"
                @click="export2Excel"
              >
                <i class="el-icon-download custom-icon"></i>
                <span>导出</span>
              </el-button>
            </div>

            <div class="custom-table-layer">
              <div style="margin-bottom: 13px">
                <vxe-grid
                  ref="xGrid"
                  border
                  size="medium"
                  resizable
                  row-id="id"
                  :treeConfig="treeConfig"
                  :proxyConfig="proxyConfig"
                  :columns="columns"
                  :rowConfig="rowConfig"
                  @cell-click="cellClick"
                >
                </vxe-grid>
              </div>
            </div>
          </div>

          <DepartmentEdit
            ref="DepartmentEdit"
            v-model:dialogVisible="dialogVisible"
            @close-dialog="closeDialog"
            @handle-cancel="handleCancel"
            @handle-confirm="handleConfirm"
          ></DepartmentEdit>
          <excel
            ref="industrialUnitExcel"
            :importurl="importurl"
            fileName="课程部门.xlsx"
            :dialogVisible="UpLoaddialogVisible"
            @close-dialog="closeUpDialog"
            @error="error"
            @success="success"
          ></excel>
        </div>
      </el-col>

      <!-- 右部分 -->
      <el-col :span="12">
        <div id="Department_right">
          <div class="search-form">
            <el-row :gutter="12">
              <el-col :span="18">
                <el-form
                  ref="form"
                  :model="form"
                  label-width="80px"
                  label-position="right"
                  size="mini"
                >
                  <el-row >
                    <el-col :span="12">
                      <el-form-item label="用户名称">
                        <el-input
                          id="name"
                          v-model="RightPageQuery.queryModel.userName"
                          placeholder="用户名称"
                          clearable
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="手机号">
                        <el-input
                          id="phone"
                          v-model="RightPageQuery.queryModel.phone"
                          placeholder="手机号"
                          clearable
                        />
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </el-col>
              <el-col :span="6">
                <el-form-item>
                  <el-button
                    size="mini"
                    class="hbn-button-serach"
                    @click="GetDepartmentUserData"
                    >查找</el-button
                  >
                  <!-- <span class="control-collapse" @click="show = !show">{{
                    show ? "收起" : "展开"
                  }}</span> -->
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <div class="hbn-table-screen">
            <div class="operation">
              <el-button
                class="custom-button"
                type="primary"
                :disabled="RightPageQuery.queryModel.id == '0'"
                @click="DepartmentUserEdit(0, 'adduser')"
                style="width: 6rem"
              >
                <i class="el-icon-circle-plus-outline custom-icon"></i>
                <span>添加成员</span>
              </el-button>

              <el-button
                class="custom-button"
                type="primary"
                :disabled="
                  multipleSelection.records == undefined ||
                  multipleSelection.records.length == 0
                "
                v-show="showBtnRemoveUser"
                @click="DepartmentUserEdit(0, 'deluser')"
              >
                <i class="el-icon-circle-delete-outline custom-icon"></i>
                <span>移除</span>
              </el-button>
            </div>

            <div class="custom-table-layer">
              <div style="margin-bottom: 13px">
                <vxe-table
                  :data="DepartmentUserDataList"
                  round
                  border
                  height="388"
                  class="mytable-scrollbar"
                  style="width: 100%"
                  :highlight-current-row="true"
                  @checkbox-all="handleSelectionAllChange"
                  @current-change="handleCurrentChange"
                  @checkbox-change="handleSelectionChange"
                  ref="multipleTable"
                  highlight-hover-row
                  highlight-hover-column
                  highlight-current-column
                  show-overflow="tooltip"
                  empty-text="没有更多数据了！"
                  resizable
                  stripe
                >
                  <vxe-table-column
                    fixed="left"
                    type="checkbox"
                    width="40"
                  ></vxe-table-column>
                  <vxe-table-column
                    fixed="left"
                    type="seq"
                    width="55"
                    title="序号"
                    align="center"
                  ></vxe-table-column>

                  <template
                    v-for="(item, key) in DepartmentUserList"
                    :key="key"
                  >
                    <vxe-table-column
                      :field="item.prop"
                      :title="item.label"
                      :width="item.width"
                      align="center"
                      v-if="item.isShow"
                      show-overflow-tooltip
                      :sortable="item.order"
                      :class-name="JSON.stringify(item)"
                      :formatter="formatterData"
                    />
                  </template>
                </vxe-table>
              </div>

              <div class="pagination">
                <vxe-pager
                  perfect
                  size="mini"
                  :current-page="RightPageQuery.pageindex"
                  :page-size="RightPageQuery.PageSize"
                  :page-sizes="[20, 50, 100, 500]"
                  :total="total"
                  :pager-count="5"
                  :layouts="[
                    'PrevJump',
                    'PrevPage',
                    'JumpNumber',
                    'NextPage',
                    'NextJump',
                    'FullJump',
                    'Sizes',
                    'Total',
                  ]"
                  @page-change="handlePageChange"
                >
                </vxe-pager>
              </div>
            </div>
          </div>

          <CompanyUserEdit
            ref="CompanyUserEdit"
            v-model:companyUserEditDialogVisible="companyUserEditDialogVisible"
            @close-dialog="companyUserEditCloseDialog"
            @handle-cancel="companyUserEditHandleCancel"
            @handle-confirm="companyUserEditHandleConfirm"
          ></CompanyUserEdit>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { Search, Delete } from "@element-plus/icons";
import { DepartmentList } from "@/assets/apiData/Company/DepartmentList";

import { DepartmentUserList } from "@/assets/apiData/Company/DepartmentUserList";

import {
  GetDataDepartmentList,
  DeleteDepartment,
} from "@api/Company/ApiDepartment";

import {
  GetDataByDepartmentId,
  RemoveUserToDepartment,
} from "@api/Company/ApiDepartmentUser";

import DepartmentEdit from "@comp/Company/DepartmentEdit.vue";
import CompanyUserEdit from "@comp/Company/CompanyUserEdit.vue";
import excel from "@comp/ExcelHelper/importExcel";
import Enumerable from "linq";

export default {
  data() {
    return {
      rowConfig: {
        isCurrent: true,
        isHover: true,
      },
      treeConfig: {},
      proxyConfig: {},
      columns: [
        { field: "id", title: "id", visible: false },
        { field: "code", title: "部门编码", width: 100, treeNode: true },
        { field: "name", title: "部门名称", width: 200 },
        { field: "level", title: "部门级别", width: 100 },
        // { field: "creatorId", title: "创建人", width: 100 },
        { field: "creationTime", title: "创建时间", width: 200 },
      ],
      tableData: [],
      tableColumn: [
        { field: "name", title: "名称", width: 200, treeNode: "true" },
        { field: "code", title: "部门代码", width: 100 },
        { field: "level", title: "部门级别", width: 100 },
        { field: "creatorId", title: "创建人", width: 100 },
        { field: "creationTime", title: "创建时间", width: 200 },
      ],
      tableTreeConfig: {
        children: "children",
        accordion: true, // 一层只允许展开一个节点
        expandAll: false, // 默认是否全部展开
      },
      PageQuery: {
        queryModel: {},
        pageindex: 1,
        PageSize: 10000,
      },
      RightPageQuery: {
        queryModel: {
          id: 0, //部门id
          userName: "", //用户名称
        },
        pageindex: 1,
        PageSize: 20,
      },
      DepartmentUserDataList: [],
      DepartmentUserTotal: 0,
      total: 0,
      companyUserEditDialogVisible: false,
      multipleSelection: [],
      dialogVisible: false,
      UpLoaddialogVisible: false,
      seldata: {
        dialogGUID: "",
        dialogtype: "",
      },
      show: false,
      Unit: {
        CodeID: "",
        Name: "",
      },
      UnitList: [],
      DataList: [],
      url: "",
      importurl: "/api/IndustrialUnit/ImportExcel?tabname=IndustrialUnit",
      currRow: {},
      DepartmentUserList: [],
      showBtnRemoveUser: true,
    };
  },
  components: {
    DepartmentEdit,
    CompanyUserEdit,
    excel,
    Search,
  },
  computed: {
    checkendSum() {
      return this.multipleSelection.length;
    },
  },
  methods: {
    error() {},
    success() {},
    closeUpDialog() {
      this.UpLoaddialogVisible = false;
    },
    importExcel() {
      this.UpLoaddialogVisible = true;
    },
    export2Excel() {
      const v = this;
      require.ensure([], () => {
        const { export_json_to_excel } = require("@/excel/Export2Excel.js"); //必须使用绝对路径
        debugger;

        const tHeader = [
          ...Enumerable.from(v.UnitList)
            .select((item) => {
              return item.label;
            })
            .toArray(),
        ]; // 标题
        const filterVal = [
          ...Enumerable.from(v.UnitList)
            .select((item) => {
              return item.prop;
            })
            .toArray(),
        ]; // 导出的字段名
        const list = v.DataList;
        const data = v.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, `课程部门`);
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    handleClick(index, type) {
      console.log(index, type);

      this.DepartmentEdit(index, type);
    },
    cellClick(select) {
      if (this.currRow == select.row) return;
      this.currRow = select.row;
      this.RightPageQuery.queryModel.id = select.row.id;
      this.RightPageQuery.pageindex = 1;
      this.GetDepartmentUserData();
    },
    //1,通过部门id获取部门下用户
    GetDepartmentUserData() {
      let _this = this;
      GetDataByDepartmentId(this.RightPageQuery).then((res) => {
        _this.DepartmentUserDataList = res.entities;
        _this.DepartmentUserTotal = res.totalCount;
      });
    },
    DepartmentUserEdit(index, type) {
      var _this = this;
      if (_this.RightPageQuery.queryModel.id == "0") {
        _this.$message.error("请先选择一个部门!");
        return;
      }
      if (type == "deluser") {
        if (_this.multipleSelection.records == undefined) {
          _this.$message.error("必须选择一个用户!");
          return;
        }
        var departmentUserIds = [];
        _this.multipleSelection.records.forEach((x) => {
          departmentUserIds.push(x.departmentUserId);
        });
        if (departmentUserIds.length == 0) {
          _this.$message.error("必须选择一个用户!");
          return;
        }
        _this
          .$confirm("确定移除吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
          .then(() => {
            _this.showBtnRemoveUser = false;
            RemoveUserToDepartment(departmentUserIds).then(function (data) {
              if (data) {
                _this.$message.success("删除成功");
                _this.showBtnRemoveUser = true;
                _this.RightPageQuery.pageindex = 1;
                _this.RightPageQuery.queryModel.userName = "";
                _this.RightPageQuery.queryModel.phone = "";

                _this.GetDepartmentUserData();
              }
            });
          });
      } else {
        _this.companyUserEditDialogVisible = true;
        _this.$refs.CompanyUserEdit.loadDataById(
          _this.RightPageQuery.queryModel.id
        );
      }
    },
    companyUserEditCloseDialog() {
      this.companyUserEditDialogVisible = false;
      this.RightPageQuery.pageindex = 1;
      this.GetDepartmentUserData();
    },
    companyUserEditHandleCancel() {
      this.companyUserEditDialogVisible = false;
      this.RightPageQuery.pageindex = 1;
      this.GetDepartmentUserData();
    },
    companyUserEditHandleConfirm() {
      this.companyUserEditDialogVisible = false;
      this.RightPageQuery.pageindex = 1;
      this.GetDepartmentUserData();
    },
    DepartmentEdit(index, type) {
      var _this = this;
      if (index != -1 && _this.currRow.id == undefined) {
        _this.$message.error("请选择一个节点!");
        return;
      }
      if (type == "Delete") {
        _this
          .$confirm("确定删除吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
          .then(() => {
            DeleteDepartment(_this.currRow.id).then(function (data) {
              if (data) {
                _this.$message.success("删除成功");
                _this.ResetData();
              }
            });
          })
          .catch(() => {});
      } else {
        if (type == "Add" && _this.currRow.levlel == 3) {
          _this.$message.error("子节点最多只有三级!");
          return;
        }
        _this.dialogVisible = true;
        _this.$refs.DepartmentEdit.loadDataById(_this.currRow, type);
      }
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionAllChange(val) {
      this.multipleSelection = val;
    },
    //选中事件
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    seach() {
      this.PageQuery.pageindex = 1;

      const $grid = this.$refs.xGrid;
      $grid.commitProxy("query");
    },
    handleSizeChange(val) {
      //分页
    },
    handlePageChange({ currentPage, pageSize }) {
      if (this.RightPageQuery.PageSize != pageSize) {
        this.RightPageQuery.pageindex = 1; //说明更改了每页展示条数，要从第一页进行展示
        this.RightPageQuery.PageSize = pageSize;
      } else {
        this.RightPageQuery.pageindex = currentPage;
      }
      const $grid = this.$refs.xGrid;
      $grid.commitProxy("query");
    },
    handleCurrentChange(val) {
      console.log(val);
      const $grid = this.$refs.xGrid;
      $grid.commitProxy("query");
    },
    dateFormat(fmt, date) {
      let ret;
      const opt = {
        "Y+": date.getFullYear().toString(), // 年
        "m+": (date.getMonth() + 1).toString(), // 月
        "d+": date.getDate().toString(), // 日
        "H+": date.getHours().toString(), // 时
        "M+": date.getMinutes().toString(), // 分
        "S+": date.getSeconds().toString(), // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
      };
      for (let k in opt) {
        ret = new RegExp("(" + k + ")").exec(fmt);
        if (ret) {
          fmt = fmt.replace(
            ret[1],
            ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, "0")
          );
        }
      }
      return fmt;
    },
    async GetData(parentId = 0) {
      const _this = this;
      this.SearchDataInfo();

      this.PageQuery.queryModel.parentId = parentId;

      return await GetDataDepartmentList(_this.PageQuery).then(function (data) {
        data.entities.forEach((x) => {
          x.isHasChild = true;
          x.creationTime = _this.dateFormat(
            "YYYY-mm-dd HH:MM:SS",
            new Date(x.creationTime)
          );
        });
        _this.tableData = data.entities;
        //_this.total = data.totalCount;
        return data.entities;
      });
    },
    SearchDataInfo() {},
    closeDialog() {
      this.dialogVisible = false;
    },
    handleCancel() {
      this.dialogVisible = false;
    },
    ResetData() {
      this.DepartmentUserDataList = [];
      this.RightPageQuery.pageindex = 1;
      this.PageQuery.pageindex = 1;
      this.currRow = {};

      const $grid = this.$refs.xGrid;
      $grid.commitProxy("query");
    },
    handleConfirm(val) {
      this.dialogVisible = false;
      this.ResetData();
    },
    initData() {
      var _this = this;
      this.treeConfig = {
        lazy: true,
        transform: true,
        rowField: "id",
        parentField: "parentId",
        hasChild: "isHasChild", // 设置是否有子节点标识
        reserve: true,
        loadMethod({ row }) {
          // 模拟后台接口
          return new Promise((resolve) => {
            var list = _this.GetData(row.id);

            resolve(list);
          });
        },
      };
      this.proxyConfig = {
        ajax: {
          query: () => {
            return new Promise((resolve) => {
              var list = this.GetData(0);

              resolve(list);
            });
          },
        },
      };
    },
  },
  created() {
    this.DepartmentUserList = DepartmentUserList;
    this.initData();
  },
};
</script>
<style lang="scss" scoped>
@import "@/common/css/Hbn_modules/reset-input";
.custom-table-header > th {
  background: #dfdfdf !important;
}

.custom-table-header > th > .cell {
  font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
  font-weight: 500;
  color: #868686 !important;
  line-height: 22px;
}

.custom-table-layer ::v-deep .el-table .cell {
  color: #32383d;
}
.el-table .cell {
  color: #32383d;
}

.el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar {
  display: none;
}
.custom-table-layer .el-pagination.is-background .btn-prev,
.custom-table-layer .el-pagination.is-background .btn-next,
.custom-table-layer .el-pagination.is-background .el-pager li {
  border: 1px solid #acb5bd;
  width: 32px;
  height: 32px;
  line-height: 32px;
  background-color: #fff;
}
</style>
<style lang="scss" scoped>
@import "@/common/css/Hbn_modules/hbn-base-model";
</style>
<style scoped>
</style>
